// extracted by mini-css-extract-plugin
module.exports = {"t1k33q0w":"t1k33q0w","tfn08jb":"tfn08jb","a6iob7g":"a6iob7g"};